import React from 'react';

const SidebarTitle = ({ title, classOption = "sidebar-widget-title" }) => {
    return (
        <React.Fragment>
            <h3 className={`sidebar-widget-title ${classOption}`}>{title}</h3>
        </React.Fragment>
    )
}

export default SidebarTitle;
